import {
  Component,
  HostListener,
  Input,
  OnInit,
  TemplateRef,
} from '@angular/core';
import {
  DeviceDetectorService,
  OperativeService,
  PortfolioInterface,
} from '@techrules/portallib';
import { Router } from '@angular/router';
import { CommonService } from '@tech-services/common.service';
import { SessionService } from '@tech-services/session.service';
import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from '@tech-utils/app-config.service';
import { formatDate } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { TechDialogsService } from '../../../shared/tech-dialogs.service';
import { ModalCustomDateReportComponent } from '../../../shared/modal-custom-date-report/modal-custom-date-report.component';
import { OperativePageState } from '../../main/operative/operative.enums';
import { OperativeDataService } from '../../main/operative/operative.data.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ActionItemEnum } from './action-item.enum';
import { ActionItemInterface } from './action-item.interface';
import { ActionItem } from './action-item.model';
import { ProfileportfolioService } from '@tech-services/profileportfolio.service';
import { ModalCustomAccountStatementComponent } from '../../../shared/modal-custom-account-statement/modal-custom-account-statement.component';
import { DocmanagerService } from '@techrules/portallib';
import { throwError } from 'rxjs';

@Component({
  selector: 'tech-portfolio-item',
  templateUrl: './portfolio-item.component.html',
  styleUrls: ['./portfolio-item.component.scss'],
})
export class PortfolioItemComponent implements OnInit {
  @Input() item: PortfolioInterface;
  @Input() enableClick: boolean = true;
  @Input() enableHover: boolean = true; // Por defecto, el hover está habilitado
  @Input() showBack: boolean;

  dateFormat: string = this.sessionService.dateFormat
    .replace('DD', 'dd')
    .replace('YYYY', 'yyyy')
    .replace('MMM', 'MM');
  isMovil: boolean;
  reportWithDate: boolean = AppConfig.settings.reportWithDate;
  iconPortfolio: boolean = AppConfig.settings.iconPortfolio;
  topBorderCard: boolean = AppConfig.settings.topBorderCard;
  isProfileportfolio: boolean = this.router.url.endsWith('/profileportfolio');
  accountStatementsinPortfolio: boolean =
    AppConfig.settings.accountStatementsInPortfolio;

  actionsItems: ActionItem[] = [];
  actionLimit: number = 3;
  actionLastLimit: number = 0;

  constructor(
    private readonly commonService: CommonService,
    private readonly sessionService: SessionService,
    private readonly router: Router,
    private readonly deviceService: DeviceDetectorService,
    private readonly translate: TranslateService,
    private readonly dialogService: TechDialogsService,
    private readonly operativeData: OperativeDataService,
    public dialog: MatDialog,
    private readonly service: OperativeService,
    private readonly bottomSheet: MatBottomSheet,
    private readonly profilePortfolioService: ProfileportfolioService,
    private docmanagerService: DocmanagerService
  ) {}

  ngOnInit(): void {
    this.isMovil = this.deviceService.isMobile();

    let actionItem: ActionItem;

    if (this.item.AllowOperations) {
      const _operations = this.item.AllowOperations;

      // PDF...
      if (AppConfig.settings.portfolioReportClientPortal) {
        actionItem = new ActionItem();
        actionItem.allow = true;
        actionItem.icon = 'file-chart-line';
        (actionItem.id = ActionItemEnum.PortfolioReportClient),
          (actionItem.label = 'k000067');
        actionItem.visible = true;
        this.actionsItems.push(actionItem);
      }
      //AccountStaments
      if (AppConfig.settings.accountStatementsInPortfolio) {
        actionItem = new ActionItem();
        actionItem.allow = true;
        actionItem.icon = 'file-chart-line';
        (actionItem.id = ActionItemEnum.AccountStatements),
          (actionItem.label = 'k004375');
        actionItem.visible = true;
        this.actionsItems.push(actionItem);
      }

      // Allow Contribution
      if (_operations.VisibleContribution) {
        actionItem = new ActionItem();
        actionItem.allow = _operations.AllowContribution;
        actionItem.icon = 'sign-in';
        actionItem.id = ActionItemEnum.Contribution;
        actionItem.label = 'k000521';
        actionItem.message = _operations.MessageContribution;
        actionItem.rotate = 90;
        actionItem.visible = _operations.VisibleContribution;
        this.actionsItems.push(actionItem);
      }

      // Allow Withdrawal
      if (_operations.VisibleWithdrawal) {
        actionItem = new ActionItem();
        actionItem.allow = _operations.AllowWithdrawal;
        actionItem.icon = 'sign-out';
        actionItem.id = ActionItemEnum.Withdrawal;
        actionItem.label = 'k000139';
        actionItem.message = _operations.MessageWithdrawal;
        actionItem.rotate = 270;
        actionItem.visible = _operations.VisibleWithdrawal;
        this.actionsItems.push(actionItem);
      }

      // Allow Cancel contribution
      if (_operations.VisibleCancelContribution) {
        actionItem = new ActionItem();
        actionItem.allow = _operations.AllowCancelContribution;
        actionItem.icon = 'xmark';
        actionItem.id = ActionItemEnum.CancelContribution;
        actionItem.label = 'k003539';
        actionItem.message = _operations.MessageCancelContribution;
        actionItem.visible = _operations.VisibleCancelContribution;
        this.actionsItems.push(actionItem);
      }

      // Allow Cancel Withdrawal
      if (_operations.VisibleCancelWithdrawal) {
        actionItem = new ActionItem();
        actionItem.allow = _operations.AllowCancelWithdrawal;
        actionItem.icon = 'xmark';
        actionItem.id = ActionItemEnum.CancelWithdrawal;
        actionItem.label = 'k003540';
        actionItem.message = _operations.MessageCancelWithdrawal;
        actionItem.visible = _operations.VisibleCancelWithdrawal;
        this.actionsItems.push(actionItem);
      }

      // Allow Contribution Proposal
      if (_operations.VisibleContributionProposal) {
        actionItem = new ActionItem();
        actionItem.allow = _operations.AllowContributionProposal;
        actionItem.icon = 'sign-in';
        actionItem.id = ActionItemEnum.ContributionProposal;
        actionItem.label = 'k000521';
        actionItem.message = _operations.MessageContributionProposal;
        actionItem.rotate = 90;
        actionItem.visible = _operations.VisibleContributionProposal;
        this.actionsItems.push(actionItem);
      }

      // Allow Withdrawal Proposal
      if (_operations.VisibleWithdrawalProposal) {
        actionItem = new ActionItem();
        actionItem.allow = _operations.AllowWithdrawalProposal;
        actionItem.icon = 'sign-out';
        actionItem.id = ActionItemEnum.WithdrawalProposal;
        actionItem.label = 'k000139';
        actionItem.message = _operations.MessageWithdrawalProposal;
        actionItem.rotate = 270;
        actionItem.visible = _operations.VisibleWithdrawalProposal;
        this.actionsItems.push(actionItem);
      }

      // Allow Cancel Contribution Proposal
      if (_operations.VisibleCancelContributionProposal) {
        actionItem = new ActionItem();
        actionItem.allow = _operations.AllowCancelContributionProposal;
        actionItem.icon = 'xmark';
        actionItem.id = ActionItemEnum.CancelContributionProposal;
        actionItem.label = 'k003540';
        actionItem.message = _operations.MessageCancelContributionProposal;
        actionItem.visible = _operations.VisibleCancelContributionProposal;
        this.actionsItems.push(actionItem);
      }

      // Allow Cancel Withdrawal Proposal
      if (_operations.VisibleCancelWithdrawalProposal) {
        actionItem = new ActionItem();
        actionItem.allow = _operations.AllowCancelWithdrawalProposal;
        actionItem.icon = 'xmark';
        actionItem.id = ActionItemEnum.CancelWithdrawalProposal;
        actionItem.label = 'k003540';
        actionItem.message = _operations.MessageCancelWithdrawalProposal;
        actionItem.visible = _operations.VisibleCancelWithdrawalProposal;
        this.actionsItems.push(actionItem);
      }

      // Allow Periodic Contribution Proposal
      if (_operations.VisiblePeriodicContributionProposal) {
        actionItem = new ActionItem();
        actionItem.allow = _operations.AllowPeriodicContributionProposal;
        actionItem.icon = 'arrow-rotate-right';
        actionItem.id = ActionItemEnum.PeriodicContributionProposal;
        actionItem.label = 'k000547';
        actionItem.message = _operations.MessagePeriodicContributionProposal;
        actionItem.visible = _operations.VisiblePeriodicContributionProposal;
        this.actionsItems.push(actionItem);
      }

      // Allow Cancel Periodic Contribution Proposal
      if (_operations.VisibleCancelPeriodicContributionProposal) {
        actionItem = new ActionItem();
        actionItem.allow = _operations.AllowCancelPeriodicContributionProposal;
        actionItem.icon = 'xmark';
        actionItem.id = ActionItemEnum.CancelPeriodicContributionProposal;
        actionItem.label = 'k003769';
        actionItem.message =
          _operations.MessageCancelPeriodicContributionProposal;
        actionItem.visible =
          _operations.VisibleCancelPeriodicContributionProposal;
        this.actionsItems.push(actionItem);
      }

      // Allow Change Model Portfolio
      if (_operations.VisibleChangeModelPortfolio) {
        actionItem = new ActionItem();
        actionItem.allow = _operations.AllowChangeModelPortfolio;
        actionItem.icon = 'arrow-right-arrow-left';
        actionItem.id = ActionItemEnum.ChangeModelPortfolio;
        actionItem.label = 'k003010';
        actionItem.message = _operations.MessageChangeModelPortfolio;
        actionItem.visible = _operations.VisibleChangeModelPortfolio;
        this.actionsItems.push(actionItem);
      }

      // Allow Change Model Portfolio Proposal
      if (_operations.VisibleChangeModelPortfolioProposal) {
        actionItem = new ActionItem();
        actionItem.allow = _operations.AllowChangeModelPortfolioProposal;
        actionItem.icon = 'arrow-right-arrow-left';
        actionItem.id = ActionItemEnum.ChangeModelPortfolioProposal;
        actionItem.label = 'k003010';
        actionItem.message = _operations.MessageChangeModelPortfolioProposal;
        actionItem.visible = _operations.VisibleChangeModelPortfolioProposal;
        this.actionsItems.push(actionItem);
      }

      // Allow Operation Portfolio
      if (_operations.VisibleOperatePortfolio) {
        actionItem = new ActionItem();
        actionItem.allow = _operations.AllowOperatePortfolio;
        actionItem.icon = 'chart-candlestick';
        actionItem.id = ActionItemEnum.OperatePortfolio;
        actionItem.label = 'Trade';
        actionItem.message = _operations.MessageOperatePortfolio;
        actionItem.visible = _operations.VisibleOperatePortfolio;
        this.actionsItems.push(actionItem);
      }
    }
    this.actionLastLimit = this.actionsItems.length;
  }

  /*
  openPortfolio() {
    if (this.item.PortfolioHaveComponents && this.enableClick) {
      this.commonService.portfolioCodeSource.next(this.item.PortfolioCode);
      this.sessionService.portfolioCode = this.item.PortfolioCode;
      localStorage.setItem('PortfolioCode', this.item.PortfolioCode);
      this.router.navigate(['/profileportfolio']);
    }
  }*/

  /*
  Función para abrir una cartera a una nueva página
  */
  openPortfolio() {
    if (this.item.PortfolioHaveComponents && this.enableClick) {
      this.commonService.portfolioCodeSource.next(this.item.PortfolioCode);
      this.sessionService.portfolioCode = this.item.PortfolioCode;
      localStorage.setItem('PortfolioCode', this.item.PortfolioCode);
      this.profilePortfolioService.portfolioDataSource.next({});
      this.profilePortfolioService.portfolioanalysisSource.next({});
      this.profilePortfolioService.periodSelectedSource.next({});

      this.router.navigate(['/profileportfolio']);
    }
  }

  moreEvent(event, templateRef: TemplateRef<any>) {
    event.stopPropagation();
    if (this.isMovil) {
      this.bottomSheet.open(templateRef);
    }
  }

  public viewHintHelp(event) {
    let text1: string;
    let text2: string;
    this.translate.get('k004390').subscribe((text: string) => {
      text1 = text; //Token: Total Gain/Loss
    });
    this.translate.get('k004392').subscribe((text: string) => {
      text2 = text;
      //'Total Gain/Loss shows how much the total value of your investment has increased or decreased since you made it. It is calculated by subtracting the original amount you invested, including any contributions and withdrawals, from your current portfolio value. If the result is positive, it indicates a gain; if negative, it reflects a loss.';
      this.dialogService.openModalDialog('', text1, text2, '');
    });
  }

  //NEW

  clickEvent(event, actionItem: ActionItemInterface) {
    event.stopPropagation();

    switch (actionItem.id) {
      case ActionItemEnum.PortfolioReportClient:
        this.openDialog(actionItem, event);
        break;
      case ActionItemEnum.AccountStatements:
        this.openDialogAccountStatement(actionItem, event);
        break;
      case ActionItemEnum.Contribution:
      case ActionItemEnum.ContributionProposal:
        if (actionItem.allow) {
          this.goAportacion(event);
        } else {
          this.goMessage(actionItem);
        }
        break;
      case ActionItemEnum.Withdrawal:
      case ActionItemEnum.WithdrawalProposal:
        if (actionItem.allow) {
          this.goRembolso(event);
        } else {
          this.goMessage(actionItem);
        }
        break;
      case ActionItemEnum.PeriodicContributionProposal:
        if (actionItem.allow) {
          this.goAportacion2();
        } else {
          this.goMessage(actionItem);
        }
        break;
      case ActionItemEnum.ChangeModelPortfolio:
      case ActionItemEnum.ChangeModelPortfolioProposal:
        if (actionItem.allow) {
          this.goModelPortfolioChange();
        } else {
          this.goMessage(actionItem);
        }
        break;
      default:
        break;
    }

    if (this.isMovil) {
      this.bottomSheet.dismiss(false);
    }
  }

  /*
  goAportacion() {
    this.commonService.portfolioCodeSource.next(this.item.PortfolioCode);
    this.sessionService.portfolioCode = this.item.PortfolioCode;
    this.sessionService.operativeCode = OperativePageState.contribution;
    this.router.navigate(['operative']);
    //}
  }
*/
  goAportacion(event) {
    event.stopPropagation();
    if (!this.item.AllowOperations.AllowContribution) {
      this.goMessage(this.item);
      return;
    } else {
      // if (event) event.stopPropagation();
      this.commonService.portfolioCodeSource.next(this.item.PortfolioCode);
      this.sessionService.portfolioCode = this.item.PortfolioCode;
      // this.operativeData.portfolioCode = item.PortfolioCode;
      this.sessionService.operativeCode = OperativePageState.contribution;
      this.router.navigate(['operative']);
    }
  }

  goRembolso(event) {
    event.stopPropagation();
    if (!this.item.AllowOperations.AllowWithdrawal) {
      this.goMessage(this.item);
    } else {
      // if (event) event.stopPropagation();
      this.commonService.portfolioCodeSource.next(this.item.PortfolioCode);
      this.sessionService.portfolioCode = this.item.PortfolioCode;
      // this.operativeData.portfolioCode = item.PortfolioCode;
      this.sessionService.operativeCode = OperativePageState.partial_refund;
      this.router.navigate(['operative']);
    }
  }
  /*
  goRembolso() {
    this.commonService.portfolioCodeSource.next(this.item.PortfolioCode);
    this.sessionService.portfolioCode = this.item.PortfolioCode;
    this.sessionService.operativeCode = OperativePageState.partial_refund;
    this.router.navigate(['operative']);
    //}
  }*/

  goAportacion2() {
    this.commonService.portfolioCodeSource.next(this.item.PortfolioCode);
    this.sessionService.portfolioCode = this.item.PortfolioCode;
    this.sessionService.operativeCode =
      OperativePageState.period_contribution_edit;
    this.router.navigate(['operative']);
  }

  goModelPortfolioChange() {
    this.commonService.portfolioCodeSource.next(this.item.PortfolioCode);
    this.sessionService.portfolioCode = this.item.PortfolioCode;
    this.sessionService.operativeCode =
      OperativePageState.model_portfolio_change;
    this.router.navigate(['operative']);
  }
  /*goMessage(id, item: PortfolioInterface) {
    const text1 = this.translate.instant('k003469'); //Token: Unable to complete operation
    const text2 = this.translate.instant('k003470'); //Token: Sorry, we cannot complete your operation at this time. This could be due to following reasons:
    const text3 = 'No reason registered. Please contact the administrator'; //this.translate.instant('k003471');
    const msg1 =
      item.AllowOperations.MessageContribution === ''
        ? text3
        : item.AllowOperations.MessageContribution;
    const msg2 =
      item.AllowOperations.MessageWithdrawal === ''
        ? text3
        : item.AllowOperations.MessageWithdrawal;

    if (id == 1) {
      this.dialogService.openModalDialog(
        '',
        text1,
        text2 + '</br> </br>' + msg1,
        ''
      );
    } else {
      this.dialogService.openModalDialog(
        '',
        text1,
        text2 + '</br> </br>' + msg2,
        ''
      );
    }
  }*/

  goMessage(actionItem) {
    const text1 = this.translate.instant('k003469'); //Token: Unable to complete operation
    const text2 = this.translate.instant('k003470'); //Token: Sorry, we cannot complete your operation at this time. This could be due to following reasons:
    const text3 = 'No reason registered. Please contact the administrator'; //this.translate.instant('k003471');
    const msg = actionItem.message === '' ? text3 : actionItem.message;

    this.dialogService.openModalDialog(
      '',
      text1,
      text2 + '</br> </br>' + msg,
      ''
    );
  }

  openDialog(item, event) {
    event.stopPropagation();
    if (event) event.stopPropagation();
    const dialogRef = this.dialog.open(ModalCustomDateReportComponent, {
      data: {
        initialDate: this.item.InitialDate,
        endDate: this.item.AnalysisDate,
        minDate: this.item.InitialDate,
        maxDate: this.item.AnalysisDate,
        portfolioCode: this.item.PortfolioCode,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.openPdf(
          this.item.PortfolioCode,
          formatDate(result.initialDate, 'yyyy-MM-dd', 'en_GR'),
          formatDate(result.endDate, 'yyyy-MM-dd', 'en_GR'),
          event
        );
      }
    });
  }

  openPdf(portfolioCode, initialDate, endDate, event) {
    event.stopPropagation();
    if (this.item.PortfolioHaveComponents) {
      localStorage.setItem('OpenPdf', 'portfolioreport');
      localStorage.setItem('PortfolioCode', portfolioCode);
      localStorage.setItem('InitialDate', initialDate);
      localStorage.setItem('EndDate', endDate);
      let url = AppConfig.settings.base; //window.location.href.replace('/portfolios', '');
      window.open(url + '/openpdf', '_blank');
    }
  }

  @HostListener('window:resize') onresize() {
    this.isMovil = this.deviceService.isMobile();
  }

  openDialogAccountStatement(item, event) {
    event.stopPropagation();
    if (event) event.stopPropagation();
    const dialogRef = this.dialog.open(ModalCustomAccountStatementComponent, {
      data: {
        portfolioCode: this.item.PortfolioCode, //item.PortfolioCode,
      },
    });
    dialogRef.afterClosed().subscribe((item) => {
      if (item) {
        this.getNewDocument(item);
      }
    });
  }

  public getNewDocument(item) {;
    this.commonService.loading$.emit(true);
    this.docmanagerService.getDocumentFile(item.Id).subscribe(
      (data) => {
        let mediaType = this.getMediaType(item.Type);
        this.downLoadBlobFile(data.body, mediaType, item.Filename);
        this.commonService.loading$.emit(false);
      },
      (err) => {
        this.commonService.errorManager('apirest_getDocument1', err);
        return throwError(err);
      }
    );
  }

  private downLoadBlobFile(data: any, type: string, name: string) {
    let blob = new Blob([data], { type: type });
    let url = window.URL.createObjectURL(blob);

    let a = document.createElement('a');
    document.body.appendChild(a);
    a.href = url;
    a.download = name;
    a.click();
    setTimeout(function () {
      window.URL.revokeObjectURL(url);
    }, 1000); //enough time to download report from mobile apps
  }

  private getMediaType(fileType) {
    let mediaType;
    switch (fileType) {
      case 'jpg':
        mediaType = 'image/jpeg';
        break;
      case 'png':
        mediaType = 'image/png';
        break;
      case 'gif':
        mediaType = 'image/gif';
        break;
      case 'tif':
        mediaType = 'image/tif';
        break;
      case 'txt':
        mediaType = 'text/plain';
        break;
      case 'pdf':
        mediaType = 'application/pdf';
        break;
      case 'doc':
        mediaType = 'application/msword';
        break;
      case 'docx':
        mediaType =
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        break;
      default:
        mediaType = 'image/jpeg';
        break;
    }

    return mediaType;
  }
}
